var render, staticRenderFns
import script from "./tumbling-multiplier.vue?vue&type=script&lang=js&"
export * from "./tumbling-multiplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84434de",
  null
  
)

export default component.exports